// Lazy load function
const lazyLoad = (file) => () =>
    import(
    /* webpackChunkName: "[request]" */ `@/views/production/process-capacity/${file}.vue`
    );

export default [
    {
        path: "/process-capacity",
        name: "process-capacity",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProcessCapacity",
        },
        components: {
            content: lazyLoad("process-capacity-list"),
        },
    },
    {
        path: "/exception-list",
        name: "exception-list",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "ProcessCapacity",
        },
        components: {
            content: lazyLoad("exception-list"),
        },
    },
];
